/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { CardHeader, ICardHeaderProps } from "../../Card";

export interface IFieldCardHeaderProps extends ICardHeaderProps {
	className?: string;
}

export const FieldCardHeader: React.FC<IFieldCardHeaderProps> = ({ className, children, ...props }) => {
	const baseClass = BEM("edt-field-card-header");

	if (className) {
		baseClass.add(className);
	}

	return (
		<CardHeader className={baseClass.toClassName()} {...props}>
			{children}
		</CardHeader>
	);
};
